// extracted by mini-css-extract-plugin
export default {"container":"Territories_container__ptYoU","title":"Territories_title__-dR12","list":"Territories_list__V0Q9x","link":"Territories_link__crKvl"};